import { Redirect } from 'react-router-dom';

const TestNeedsRedirect = () => <Redirect to="/tests/besoins" />;

export default TestNeedsRedirect;
